import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

export const CentreMasterReadSlice = createSlice({
  name: "CentreMasterReadSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    centreMasterRead: (state) => {
      state.isLoading = true;
    },
    successCentreMasterRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureCentreMasterRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearCentreMasterRead: (state) => {
      state.data = {};
    },
  },
});

export const {
  centreMasterRead,
  successCentreMasterRead,
  failureCentreMasterRead,
  clearCentreMasterRead,
} = CentreMasterReadSlice.actions;

export default CentreMasterReadSlice.reducer;
